// Central registry of data-testid values used throughout the dashboard.
export const TESTIDS = {
  // Auth
  loginForm: "login-form",
  loginEmail: "login-email-input",
  loginPassword: "login-password-input",
  loginSubmit: "login-submit-btn",
  logoutBtn: "logout-btn",

  // Layout
  sidebar: "main-sidebar",
  sidebarProjectsLink: "sidebar-link-projects",
  sidebarPacksLink: "sidebar-link-packs",
  sidebarSettingsLink: "sidebar-link-settings",
  topbarUser: "topbar-user",

  // Dashboard / projects list
  projectsTable: "projects-table",
  projectRow: "project-row",
  createProjectBtn: "create-project-btn",

  // Create project
  createProjectForm: "create-project-form",
  cpName: "cp-name-input",
  cpDomain: "cp-domain-input",
  cpPackSelect: "cp-pack-select",
  cpBrandName: "cp-brand-input",
  cpMonetization: "cp-monetization-select",
  cpDripPerDay: "cp-drip-input",
  cpWpUrl: "cp-wp-url-input",
  cpWpUser: "cp-wp-user-input",
  cpWpAppPwd: "cp-wp-app-pwd-input",
  cpSubmit: "cp-submit-btn",

  // Project detail
  projectTabsOverview: "project-tab-overview",
  projectTabsKeywords: "project-tab-keywords",
  projectTabsThreads: "project-tab-threads",
  projectTabsPersonas: "project-tab-personas",
  projectTabsPublishing: "project-tab-publishing",
  projectTabsOffers: "project-tab-offers",
  projectTabsLogs: "project-tab-logs",
  projectTabsSitemaps: "project-tab-sitemaps",
  projectTabsSettings: "project-tab-settings",
  testWpBtn: "test-wp-btn",

  // Keywords
  kwUploadInput: "kw-upload-input",
  kwUploadBtn: "kw-upload-btn",
  kwSeedDemoBtn: "kw-seed-demo-btn",
  kwTable: "kw-table",

  // Threads
  genCountInput: "gen-count-input",
  genServiceSelect: "gen-service-select",
  genIntentSelect: "gen-intent-select",
  genGoBtn: "gen-go-btn",
  threadsTable: "threads-table",
  threadPreviewBtn: "thread-preview-btn",
  threadDeleteBtn: "thread-delete-btn",

  // Publishing
  scheduleBatchBtn: "schedule-batch-btn",
  runQueueBtn: "run-queue-btn",
  queueTable: "queue-table",

  // Offers
  offerNameInput: "offer-name-input",
  offerTypeSelect: "offer-type-select",
  offerPhoneInput: "offer-phone-input",
  offerUrlInput: "offer-url-input",
  offerServiceInput: "offer-service-input",
  offerCreateBtn: "offer-create-btn",
  offersTable: "offers-table",

  // Moderation (real-visitor UGC)
  moderationTable: "moderation-table",
  moderationApproveBtn: "moderation-approve-btn",
  moderationRejectBtn: "moderation-reject-btn",
  moderationStatusFilter: "moderation-status-filter",
};

// kept for backward compat with template
export const HOME = { emergentLink: "home-emergent-link" };
